export function eligiblePromotions(promotions, product, now = Date.now()) {
  if (!product.available || product.currency !== 'USD') return [];
  return promotions.filter(p => {
    if (!p || !['code', 'automatic'].includes(p.method) || !p.scope || !p.saving || !p.minimum) return false;
    if (Date.parse(p.startsAt) > now || !Number.isFinite(Date.parse(p.startsAt)) || (p.endsAt && (!Number.isFinite(Date.parse(p.endsAt)) || Date.parse(p.endsAt) <= now))) return false;
    if (p.saving.currency && p.saving.currency !== product.currency || p.minimum.currency && p.minimum.currency !== product.currency) return false;
    if (p.method === 'code' && !p.code) return false;
    if (!Number.isFinite(p.saving.value) || p.saving.value <= 0) return false;
    return p.scope.all || p.scope.products?.includes(product.id) || p.scope.variants?.includes(product.variantId) || p.scope.collections?.some(id => product.collections.includes(id));
  }).sort((a,b) => a.minimum.amount - b.minimum.amount || a.minimum.quantity - b.minimum.quantity || b.saving.value - a.saving.value);
}

const configElement = document.getElementById('hol-promotion-config');
if (configElement) {
  const config = JSON.parse(configElement.textContent);
  const strings = config.strings;
  let catalog, pending, timer, expiryTimer;
  function validCatalog(result) { return result?.version === 1 && result.mode === 'live' && Array.isArray(result.promotions) && Number.isFinite(result.expiresAt) && result.expiresAt > Date.now() && result.expiresAt - Date.now() <= 20 * 60 * 1000; }
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: value % 100 ? 2 : 0 }).format(value / 100);
  const text = (key, vars = {}) => Object.entries(vars).reduce((s, [k,v]) => s.replaceAll(`__${k}__`, String(v)), strings[key] || key);
  const element = (tag, className, value) => { const el = document.createElement(tag); if (className) el.className = className; if (value) el.textContent = value; return el; };
  function icon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('class', 'hol-promo-icon'); svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', 'M20 13 11 22 2 13V4h9l9 9Z M7 8h.01'); path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.6'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round'); svg.append(path); return svg;
  }
  function updateAll() { document.querySelectorAll('hol-promotion-display').forEach(el => el.render()); }
  async function refresh() {
    if (pending) return pending;
    pending = (async () => {
      try {
        const url = config.endpoint + '&_promo=' + Math.floor(Date.now() / 60000);
        const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(8000) });
        if (!response.ok) throw new Error('Offers unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = JSON.parse(html.getElementById('hol-promotion-data')?.dataset.catalog || 'null');
        if (!validCatalog(result)) throw new Error('Expired offer catalog');
        catalog = result;
        clearTimeout(expiryTimer);
        if (!config.preview) expiryTimer = setTimeout(() => { catalog = null; updateAll(); }, Math.max(0, result.expiresAt - Date.now()));
      } catch { catalog = null; }
      updateAll();
    })().finally(() => { pending = null; clearTimeout(timer); if (!config.preview && document.visibilityState === 'visible') timer = setTimeout(refresh, 60000); });
    return pending;
  }
  try { const initial = JSON.parse(document.getElementById('hol-promotion-data')?.dataset.catalog || 'null'); if (validCatalog(initial)) { catalog = initial; expiryTimer = setTimeout(() => { catalog = null; updateAll(); }, initial.expiresAt - Date.now()); } } catch {}
  class HolPromotionDisplay extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.closest('.shopify-section')?.addEventListener('shopify:product:select', this.variantChange, { signal: this.abort.signal });
      this.render(); if (!catalog) refresh();
    }
    disconnectedCallback() { this.abort?.abort(); this.generation = (this.generation || 0) + 1; }
    variantChange = event => {
      const sourceCard = event.target?.closest?.('product-card');
      if (sourceCard && !sourceCard.contains(this)) return;
      if (!sourceCard && this.closest('product-card')) return;
      this.hidden = true; this.variantChanging = true;
      const generation = this.generation = (this.generation || 0) + 1;
      Promise.resolve(event.promise).then(result => {
        if (!this.isConnected || generation !== this.generation) return;
        const candidates = result?.detail?.html?.querySelectorAll('hol-promotion-display');
        const next = Array.from(candidates || []).find(el => el.dataset.mode === this.dataset.mode && (!this.closest('product-card') || el.dataset.productId === this.dataset.productId));
        if (!next) return;
        for (const key of ['productId','variantId','price','available','currency','collections']) this.dataset[key] = next.dataset[key];
        this.variantChanging = false; this.render();
      }).catch(() => { this.hidden = true; });
    };
    render() {
      if (this.variantChanging) { this.hidden = true; return; }
      if (!catalog || !config.preview && catalog.expiresAt <= Date.now()) { this.hidden = true; return; }
      const promotions = eligiblePromotions(catalog.promotions, { id: this.dataset.productId, variantId: this.dataset.variantId, currency: this.dataset.currency, available: this.dataset.available === 'true', collections: this.dataset.collections.split(',') });
      this.hidden = !promotions.length;
      if (!promotions.length) { this.replaceChildren(); this.signature = null; return; }
      const signature = JSON.stringify([promotions, this.dataset.mode, config.preview]);
      if (signature === this.signature) return;
      this.signature = signature; this.replaceChildren();
      if (this.dataset.mode !== 'panel') {
        const badge = element(this.dataset.mode === 'gallery' ? 'a' : 'span', 'hol-promo-badge');
        const codes = promotions.some(p => p.method === 'code'), autos = promotions.some(p => p.method === 'automatic');
        badge.append(icon(), document.createTextNode(text(this.dataset.placement === 'plp' ? 'badge_bonus' : codes && autos ? 'badge_mixed' : codes ? 'badge_code' : 'badge_auto')));
        if (this.dataset.mode === 'gallery') { const panel = this.closest('.shopify-section')?.querySelector('hol-promotion-display[data-mode="panel"]'); if (panel) badge.href = `#${panel.id}`; }
        this.append(badge); return;
      }
      const panel = element('section', 'hol-promo-panel'); panel.setAttribute('aria-label', text('heading'));
      const heading = element('h3', 'hol-promo-heading'); heading.append(icon(), document.createTextNode(text('heading')));
      panel.append(heading, element('p', 'hol-promo-intro', text('intro')));
      const status = element('p', 'hol-promo-status'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      const renderOffer = promo => {
        const row = element('div', 'hol-promo-row');
        const copy = element('div');
        const amount = promo.saving.type === 'percentage' ? `${Number(promo.saving.value.toFixed(2))}%` : money(promo.saving.value);
        copy.append(element('strong', 'hol-promo-saving', text(promo.saving.perItem && !promo.orderDiscount ? 'saving_each' : 'saving', { amount })));
        const conditions = [];
        if (promo.minimum.amount > 0) conditions.push(text(promo.orderDiscount ? 'spend_order' : 'spend', { amount: money(promo.minimum.amount) }));
        if (promo.minimum.quantity > 1) conditions.push(text('quantity', { quantity: promo.minimum.quantity }));
        if (!conditions.length) conditions.push(text('no_minimum'));
        if (promo.oncePerCustomer) conditions.push(text('once_customer'));
        if (!promo.saving.perItem && !promo.orderDiscount) conditions.push(text('once_order'));
        if (promo.method === 'automatic') conditions.push(text('automatic_condition'));
        copy.append(element('span', 'hol-promo-condition', conditions.join(' · ')));
        row.append(copy);
        if (promo.method === 'code') {
          const button = element('button', 'hol-promo-code', promo.code); button.type = 'button'; button.setAttribute('aria-label', text('copy_code', { code: promo.code }));
          const glyph = element('span', null, '⧉'); glyph.setAttribute('aria-hidden', 'true'); button.append(glyph);
          button.addEventListener('click', async () => {
            let copyTimeout;
            try {
              await Promise.race([navigator.clipboard.writeText(promo.code), new Promise((_, reject) => { copyTimeout = setTimeout(() => reject(new Error('Copy unavailable')), 2000); })]);
              status.textContent = text('copied', { code: promo.code });
            }
            catch { status.textContent = text('copy_fallback', { code: promo.code }); }
            finally { clearTimeout(copyTimeout); }
          });
          row.append(button);
        } else row.append(element('span', 'hol-promo-auto', text('automatic')));
        return row;
      };
      promotions.slice(0,3).forEach(p => panel.append(renderOffer(p)));
      if (promotions.length > 3) {
        const details = element('details', 'hol-promo-more'); details.append(element('summary', null, text('more', { count: promotions.length - 3 })));
        promotions.slice(3).forEach(p => details.append(renderOffer(p))); panel.append(details);
      }
      panel.append(status, element('p', 'hol-promo-terms', text(promotions.some(p => p.method === 'code') ? 'terms' : 'terms_auto')));
      if (config.preview) panel.append(element('p', 'hol-promo-preview', text('preview')));
      this.append(panel);
    }
  }
  timer = setTimeout(refresh, 60000);
  if (!customElements.get('hol-promotion-display')) customElements.define('hol-promotion-display', HolPromotionDisplay);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && !config.preview) refresh(); else clearTimeout(timer); });
  window.addEventListener('pageshow', () => { if (!config.preview) refresh(); });
}
